/**
 * Error thrown when an insert targets a key that already exists in the data store.
 * Distinguishes an expected duplicate-key outcome (which callers may choose to recover from,
 * for example by treating the existing record as authoritative) from real storage failures
 * that warrant error telemetry.
 */
export class DuplicateKeyError extends Error {
	/**
	 * @constructor
	 * @param message Human-readable description of which record already existed and in which table.
	 */
	constructor(message: string) {
		super(message);
		this.name = 'DuplicateKeyError';
		// Restore the prototype chain when targeting ES5 (TS compilation target downlevels Error).
		Object.setPrototypeOf(this, DuplicateKeyError.prototype);
	}
}
